import { SyntheticEvent, useCallback, useRef } from 'react';
import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect';

export const useEventCallback = <E extends Event | SyntheticEvent>(
  callback: (event: E, ...args: any[]) => void
) => {
  const ref = useRef(callback);

  useIsomorphicLayoutEffect(() => {
    ref.current = callback;
  });

  const effect = useCallback((event: E, ...args: any[]) => ref.current(event, ...args), []);

  return effect;
};

export default useEventCallback;
